import { Button, Popover, PopoverButton, StyledPopoverPanel, PopoverItem, Indicator } from '@crazyegginc/hatch';
import { humanizeMetric } from '../utils';
import { atom, useAtom } from 'jotai';
import { useEffect } from 'react';

function columnsFor(dimension) {
  if (dimension === 'pages') return ['pageViews'];
  return ['visitors', 'pageViews', 'sessions'];
}

const lastValidMetricAtom = atom(null);

export function ColumnSelector({ dimension, onSelect, selected }) {
  const [lastValidMetric, setLastValidMetric] = useAtom(lastValidMetricAtom);
  const selectedColumn = typeof selected === 'object' ? selected.id : selected;
  const validColumns = columnsFor(dimension);

  useEffect(() => {
    if (validColumns.includes(selectedColumn)) {
      if (lastValidMetric !== selectedColumn) {
        setLastValidMetric(selectedColumn);
      }
    } else if (!lastValidMetric) {
      setLastValidMetric(validColumns[0]);
    }
  }, [validColumns, selectedColumn, lastValidMetric, setLastValidMetric]);

  const effectiveMetric = lastValidMetric ?? validColumns[0];

  return (
    <Popover className="relative">
      {({ open }) => (
        <>
          <PopoverButton as={Button} variant="secondary" size="lg" className={open ? '!border-dodger-blue-500' : ''}>
            {humanizeMetric(effectiveMetric)}
            <Indicator type="dropdown" className="ml-2.5" />
          </PopoverButton>

          <StyledPopoverPanel align="center">
            {({ close }) => (
              <>
                {validColumns.map((col) => (
                  <PopoverItem
                    key={`popover_column_${col}`}
                    autoWidth
                    onClick={() => {
                      onSelect(col);
                      close();
                    }}
                  >
                    {humanizeMetric(col)}
                  </PopoverItem>
                ))}
              </>
            )}
          </StyledPopoverPanel>
        </>
      )}
    </Popover>
  );
}
